export class LeadFilterModel {
    filters: any;
    value: [];
    slidervalue: Number = 0;
    date: any;
    from_date: any;
    to_date: any;
}
